import * as React from "react";
import { Trans } from "react-i18next";
const COMPONENTS = {
  code: /* @__PURE__ */ React.createElement("code", null),
  emphasis: /* @__PURE__ */ React.createElement("i", null),
  exampleCode: /* @__PURE__ */ React.createElement("code", { className: "text-nowrap" }),
  kbd: /* @__PURE__ */ React.createElement("kbd", null),
  lineBreak: /* @__PURE__ */ React.createElement("br", null)
};
const HelpText = ({ i18nKey, values = void 0 }) => /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(Trans, { ns: "authentication", i18nKey, values, components: COMPONENTS }));
export default HelpText;
